<section class="bk-panel ca">
  <header class="ca__head">
    <h2 class="bk-eyebrow">Preview</h2>
    <span class="ca__when">{{ whenLabel }}</span>
  </header>

  <bk-iphone-preview [senderId]="senderId" [text]="body" [at]="stampAt" />

  <!-- Who gets it and what it costs -->
  <dl class="ca__facts">
    <div class="ca__fact">
      <dt>Recipients</dt>
      <dd aria-live="polite">
        @if (!hasRecipients) {
          <span class="ca__muted">None yet</span>
        } @else if (countLoading && audienceCount === null) {
          <span class="bk-skel ca__skel" aria-hidden="true"></span>
          <span class="bk-sr-only">Counting recipients</span>
        } @else if (countError && audienceCount === null) {
          <span class="ca__muted">Not counted yet</span>
          <button type="button" class="ca__retry" (click)="retryCount.emit()">Try again</button>
        } @else if (audienceCount !== null) {
          <span class="ca__value" [class.is-stale]="countLoading">
            {{ countApprox ? "About " : "" }}{{ formatCount(audienceCount) }}
          </span>
        }
      </dd>
      @if (hasRecipients && breakdown) {
        <dd class="ca__sub">From {{ breakdown }}. Duplicates are sent once.</dd>
      }
    </div>

    <div class="ca__fact">
      <dt>Estimated SMS</dt>
      <dd>
        @if (estimatedSms !== null) {
          <span class="ca__value" [class.is-stale]="countLoading">{{ formatCount(estimatedSms) }}</span>
        } @else {
          <span class="ca__muted">—</span>
        }
      </dd>
      <dd class="ca__sub">
        @if (parts.parts) {
          {{ partsLabel }} for each recipient{{ parts.estimated ? ", estimated because of personalised fields" : "" }}.
        } @else {
          Shown once there is a message and at least one recipient.
        }
      </dd>
    </div>
  </dl>
</section>
